<template>
  <v-app>
    <v-main>
      <blink-counter />
    </v-main>
  </v-app>
</template>

<script>
import BlinkCounter from "./components/BlinkCounter";

export default {
  name: 'App',

  components: {
    BlinkCounter
  },

  data: () => ({
    //
  }),
};
</script>
